
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardFooter, CardTitle } from "@/components/ui/card";
import NewReagentFormContent from "@/components/reagents/NewReagentFormContent";
import ReagentFormActions from "@/components/reagents/ReagentFormActions";
import { useReagentFormState } from "@/hooks/useReagentFormState";
import { toast } from "sonner";

interface NewReagentFormProps {
  categories: Array<{id: string, name: string}>;
}

const NewReagentForm = ({ categories }: NewReagentFormProps) => {
  console.log("Rendering NewReagentForm with categories:", categories);
  
  const navigate = useNavigate();
  const { 
    formData, 
    errors, 
    isLoading, 
    handleChange, 
    handleSelectChange,
    handleDateChange,
    handleFileChange,
    handleSubmit,
    resetUploadState
  } = useReagentFormState(navigate);

  // Reset form state if component unmounts or errors
  useEffect(() => {
    return () => {
      console.log("NewReagentForm unmounting, resetting upload state");
      resetUploadState();
    };
  }, [resetUploadState]);

  // Handle form submission
  const onFormSubmit = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
      console.log("Form submit triggered with event, checking loading state");
    } else {
      console.log("Form submit triggered without event (button click), checking loading state");
    }
    
    if (isLoading) {
      console.log("Already uploading, ignoring duplicate submission");
      toast.info("Upload already in progress");
      return;
    }
    
    // Add more detailed logging for debugging
    console.log("About to submit form - Form data:", formData);
    console.log("About to submit form - Categories available:", categories);
    
    try {
      console.log("Calling handleSubmit");
      await handleSubmit(e);
    } catch (error) {
      console.error("Error in form submission:", error);
      toast.error(error instanceof Error ? error.message : "An unexpected error occurred");
      resetUploadState();
    }
  };

  return (
    <Card className="max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle>New Reagent</CardTitle>
      </CardHeader>
      
      <div>
        <CardContent>
          <NewReagentFormContent 
            formData={formData}
            errors={errors}
            categories={categories}
            handleChange={handleChange}
            handleSelectChange={handleSelectChange}
            handleFileChange={handleFileChange}
            handleDateChange={handleDateChange}
          />
        </CardContent>
        
        <CardFooter>
          <ReagentFormActions 
            isSubmitting={isLoading} 
            onSubmit={onFormSubmit} 
          />
        </CardFooter>
      </div>
    </Card>
  );
};

export default NewReagentForm;
